import React, { useState } from "react";

import {
  Box,
  Avatar,
  Typography,
  MobileStepper,
  TextField,
  Select,
  MenuItem,
  IconButton,
  iconList,
  Button,
  Grid,
} from "@mui/material";
import ProjectHeaderLogo from "assets/images/Group 1171275838.svg";
import ProjectImage from "assets/images/NotebookImage.svg";
import { ReactComponent as ProjectDropDownIcon } from "assets/icons/Social.svg";



const FirstStep = ({ formik, handleClick, activeStep, steps, iconList }) => {
  const [projectType, setProjectType] = useState("");
  const [selectedIcon, setSelectedIcon] = useState(false)

  const projectTypes = [
    "FOURWRD",
    "FOURCI",
    "FOURUN",
    "WAY - SIDE AMENITIES",
  ];

  const projectStatus = [
    "ONGOING", "COMPLETED"
  ]




  return (
    <>
      <Box
        sx={{
          backgroundColor: "#f3f3f3",
          minHeight: "100vh",
          p: { xs: "24px 16px", sm: "40px 24px", md: "80px 0px 0px 132px" },
          boxSizing: "border-box",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: { xs: "flex-start", md: "flex-end" },
            gap: { xs: 5, sm: 6, md: 8, lg: "326px" },
            width: "100%",
            maxWidth: "100%",
            p: { xs: 0, sm: 0, md: "7px 132px 21px 0px" },
            boxSizing: "border-box",
          }}
        >
          {/* Left Section */}
          <Box
            sx={{
              flex: 1,
              width: { xs: "100%", sm: "100%", md: "525px" },
              pl: "5px",
              maxWidth: "525px",
              display: "flex",
              flexDirection: "column",
              boxSizing: "border-box",
              overflow: "hidden"
            }}
          >
            {/* Logo */}
            <Avatar
              src={ProjectHeaderLogo}
              sx={{
                width: { xs: 50, sm: 60, md: 60 },
                height: { xs: 50, sm: 60, md: 60 },
                bgcolor: "transparent",
                "& img": {
                  objectFit: "contain",
                  width: "100%",
                  height: "100%",
                },
              }}
            />
            <Box sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: "13px",
              width: "100%",
            }}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", alignItems: "flex-start", width: "100%", p: 0 }}>
                <Typography
                  sx={{
                    mt: "0px",
                    fontWeight: 700,
                    fontSize: { xs: "28px", sm: "32px", md: "36px" },
                    lineHeight: 1.1,
                    fontFamily: "Outfit, sans-serif",
                    color: "#252C32",
                  }}
                >
                  Project Info
                </Typography>

                {/* Stepper */}
                <MobileStepper
                  variant="progress"
                  steps={steps}
                  position="relative"
                  activeStep={activeStep}
                  sx={{
                    width: { xs: "110%", sm: "110%", md: "105%" },
                    mt: 0,
                    p: 0,
                    background: "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    "& .MuiMobileStepper-progress": {
                      flexGrow: 1,
                      width: "100%",
                    },
                    "& .MuiLinearProgress-root": {
                      width: "100%",
                      backgroundColor: "#E9E9E9",
                      height: 4,
                      borderRadius: "4px",
                    },
                    "& .MuiLinearProgress-bar": {
                      backgroundColor: "#143DF2",
                    },
                  }}
                />

              </Box>
              <Typography sx={{
                fontSize: "18px",
                fontWeight: 500,
                color: "#9B9C9F",
                letterSpacing: "0px",
                fontFamily: "Outfit"
              }}>
                1/4
              </Typography>
            </Box>


            {/* Description Texts */}
            <Box
              sx={{
                mt: "15px",
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: 1.3,
                  fontFamily: "Outfit, sans-serif",
                  color: "#5B5772",
                }}
              >
                Explore what’s possible when you collaborate with your team. Edit
                project details anytime in project settings.
              </Typography>
              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  lineHeight: 1.3,
                  fontFamily: "Outfit, sans-serif",
                  color: "#5B5772",
                }}
              >
                Required fields are marked with an asterisk{" "}
                <Box component="span" sx={{ color: "#D92D20" }}>
                  *
                </Box>
              </Typography>
            </Box>

            {/* Form Fields */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: "15px", mt: "30px" }}>
              {/* Project Name */}
              <Box>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "16px",
                    fontFamily: "Outfit, sans-serif",
                    color: "#5F5F5F",
                  }}
                >
                  Project Name{" "}
                  <Box component="span" sx={{ color: "#D92D20" }}>
                    *
                  </Box>
                </Typography>
                <TextField
                  placeholder="Project Name"
                  fullWidth
                  variant="standard"
                  InputProps={{
                    disableUnderline: true,
                  }}
                  sx={{
                    mt: "15px",
                    "& .MuiInput-root": {
                      borderRadius: "8px",
                      backgroundColor: "#FFFFFF",
                      height: 48,
                      px: 2,
                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiInput-input": {
                      fontFamily: "Outfit, sans-serif",
                      padding: 0,
                      color: "#0A0A0C",
                      "&:-webkit-autofill": {
                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                        WebkitTextFillColor: "#0A0A0C !important",
                        borderRadius: "8px",
                      },
                      "&:-webkit-autofill:hover": {
                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                      },
                      "&:-webkit-autofill:focus": {
                        WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                      },
                    },
                  }}
                  name="projectName"
                  value={formik.values.projectName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.projectName && Boolean(formik.errors.projectName)}
                  helperText={formik.touched.projectName && formik.errors.projectName}

                />
              </Box>

              {/* Project Type */}
              <Box>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "16px",
                    fontFamily: "Outfit, sans-serif",
                    color: "#5F5F5F",
                  }}
                >
                  Project Type
                </Typography>
                <Box
                  sx={{
                    position: "relative",
                    width: "100%",
                    maxWidth: 350,
                    mt: "15px",
                  }}
                >

                  <ProjectDropDownIcon
                    style={{
                      position: "absolute",
                      left: 10,
                      top: "50%",
                      transform: "translateY(-50%)",
                      width: 16,
                      height: 16,
                      zIndex: 1,
                      color: "#999999"

                    }}
                  />


                  <Select
                    displayEmpty
                    name="projectType"
                    value={formik.values.projectType}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.projectType && Boolean(formik.errors.projectType)}
                    sx={{
                      width: "100%",
                      height: 44,
                      pl: 2,
                      backgroundColor: "#FFFFFF",
                      borderRadius: "6px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid #ECECEC",
                      },
                      "& .MuiSelect-select": {
                        fontSize: 16,
                        fontWeight: 400,
                        fontFamily: "Outfit, sans-serif",
                        color: "#3F3F3F",
                        display: "flex",
                        alignItems: "center",
                      },
                    }}
                  >
                    <MenuItem value="" disabled>
                      Select Project Type
                    </MenuItem>

                    {projectTypes.map((type, index) => (
                      <MenuItem key={index} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>
              <Box>
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "16px",
                    fontFamily: "Outfit, sans-serif",
                    color: "#5F5F5F",
                  }}
                >
                  Project Status
                </Typography>
                <Box
                  sx={{
                    width: "100%",
                    maxWidth: 350,
                    mt: "15px",
                  }}
                >
                  <Select
                    displayEmpty
                    name="projectStatus"
                    value={formik.values.projectStatus}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.projectStatus && Boolean(formik.errors.projectStatus)}
                    sx={{
                      width: "100%",
                      height: 44,

                      backgroundColor: "#FFFFFF",
                      borderRadius: "6px",
                      "& .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid #ECECEC",
                      },
                      "& .MuiSelect-select": {
                        fontSize: 16,
                        fontWeight: 400,
                        fontFamily: "Outfit, sans-serif",
                        color: "#3F3F3F",
                        display: "flex",
                        alignItems: "center",
                      },
                    }}
                  >
                    <MenuItem value="" disabled>
                      Select Status
                    </MenuItem>

                    {projectStatus.map((type, index) => (
                      <MenuItem key={index} value={type}>
                        {type}
                      </MenuItem>
                    ))}
                  </Select>
                </Box>
              </Box>

              <Grid container rowSpacing={1.4} columnSpacing={1}>

                <Grid size={6}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "16px",
                      fontFamily: "Outfit, sans-serif",
                      color: "#5F5F5F",
                    }}
                  >
                    Total Land
                  </Typography>
                  <TextField
                    placeholder="Total Land"
                    fullWidth
                    variant="standard"
                    InputProps={{
                      disableUnderline: true,
                    }}
                    sx={{
                      mt: "15px",
                      "& .MuiInput-root": {
                        borderRadius: "8px",
                        backgroundColor: "#FFFFFF",
                        height: 48,
                        px: 2,
                        display: "flex",
                        alignItems: "center",
                      },
                      "& .MuiInput-input": {
                        fontFamily: "Outfit, sans-serif",
                        padding: 0,
                        color: "#0A0A0C",
                        "&:-webkit-autofill": {
                          WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                          WebkitTextFillColor: "#0A0A0C !important",
                          borderRadius: "8px",
                        },
                        "&:-webkit-autofill:hover": {
                          WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                        },
                        "&:-webkit-autofill:focus": {
                          WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                        },
                      },
                    }}
                    name="TotalLand"
                    value={formik.values.TotalLand}
                    onChange={formik.handleChange}
                  />
                </Grid>

                <Grid size={6}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "16px",
                      fontFamily: "Outfit, sans-serif",
                      color: "#5F5F5F",
                    }}
                  >
                    Built-up Area
                  </Typography>
                  <TextField
                    placeholder="Built Up Area"
                    fullWidth
                    variant="standard"
                    InputProps={{
                      disableUnderline: true,
                    }}
                    sx={{
                      mt: "15px",
                      "& .MuiInput-root": {
                        borderRadius: "8px",
                        backgroundColor: "#FFFFFF",
                        height: 48,
                        px: 2,
                        display: "flex",
                        alignItems: "center",
                      },
                      "& .MuiInput-input": {
                        fontFamily: "Outfit, sans-serif",
                        padding: 0,
                        color: "#0A0A0C",
                        "&:-webkit-autofill": {
                          WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                          WebkitTextFillColor: "#0A0A0C !important",
                          borderRadius: "8px",
                        },
                        "&:-webkit-autofill:hover": {
                          WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                        },
                        "&:-webkit-autofill:focus": {
                          WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                        },
                      },
                    }}
                    name="BuiltUpArea"
                    value={formik.values.BuiltUpArea}
                    onChange={formik.handleChange}
                  />
                </Grid>

                <Grid size={6}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "16px",
                      fontFamily: "Outfit, sans-serif",
                      color: "#5F5F5F",
                    }}
                  >
                    Completion
                  </Typography>
                  <TextField
                    placeholder="Completion"
                    fullWidth
                    variant="standard"
                    InputProps={{
                      disableUnderline: true,
                    }}
                    sx={{
                      mt: "15px",
                      "& .MuiInput-root": {
                        borderRadius: "8px",
                        backgroundColor: "#FFFFFF",
                        height: 48,
                        px: 2,
                        display: "flex",
                        alignItems: "center",
                      },
                      "& .MuiInput-input": {
                        fontFamily: "Outfit, sans-serif",
                        padding: 0,
                        color: "#0A0A0C",
                        "&:-webkit-autofill": {
                          WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                          WebkitTextFillColor: "#0A0A0C !important",
                          borderRadius: "8px",
                        },
                        "&:-webkit-autofill:hover": {
                          WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                        },
                        "&:-webkit-autofill:focus": {
                          WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                        },
                      },
                    }}
                    name="DelieveredArea"
                    value={formik.values.DelieveredArea}
                    onChange={formik.handleChange}
                  />
                </Grid>

                <Grid size={6}>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "16px",
                      fontFamily: "Outfit, sans-serif",
                      color: "#5F5F5F",
                    }}
                  >
                    Leasing Percentage
                  </Typography>
                  <TextField
                    placeholder="Leasing Percentage"
                    fullWidth
                    variant="standard"
                    InputProps={{
                      disableUnderline: true,
                    }}
                    sx={{
                      mt: "15px",
                      "& .MuiInput-root": {
                        borderRadius: "8px",
                        backgroundColor: "#FFFFFF",
                        height: 48,
                        px: 2,
                        display: "flex",
                        alignItems: "center",
                      },
                      "& .MuiInput-input": {
                        fontFamily: "Outfit, sans-serif",
                        padding: 0,
                        color: "#0A0A0C",
                        "&:-webkit-autofill": {
                          WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                          WebkitTextFillColor: "#0A0A0C !important",
                          borderRadius: "8px",
                        },
                        "&:-webkit-autofill:hover": {
                          WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                        },
                        "&:-webkit-autofill:focus": {
                          WebkitBoxShadow: "0 0 0 100px #FFFFFF inset !important",
                        },
                      },
                    }}
                    name="LeasingPercentage"
                    value={formik.values.LeasingPercentage}
                    onChange={formik.handleChange}
                  />
                </Grid>
              </Grid>

              {/* Icon Selection Text */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  mt: "20px",
                  width: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    fontSize: "16px",
                    fontFamily: "Outfit, sans-serif",
                    color: "#5F5F5F",
                  }}
                >
                  Project Icon
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 400,
                    fontSize: "12px",
                    fontFamily: "Outfit, sans-serif",
                    color: "#0A65E4",
                  }}
                >
                  Select a Project Icon
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  alignItems: { xs: "flex-start", },
                  gap: { xs: "12px", md: "16px" },
                  mt: "14px",
                  flexDirection: { xs: "column", md: "row" },
                  borderRadius: "8px",
                  border: "none",
                  width: "100%",
                  height: { xs: "auto", md: "136px" },
                  p: { xs: "16px", md: "0px" },
                  backgroundColor: "#FFFFFF",
                  boxSizing: "border-box",
                }}
              >

                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: { xs: "flex-start", md: "center" },
                    width: { xs: "100%", md: "90px" },
                    height: { xs: "60px", md: "100%" },
                    minHeight: { xs: "60px", md: "100%" },
                    backgroundColor: "#F5F5F5",
                    borderRadius: { xs: "6px", md: "0px" },
                    p: "4px 9px",
                  }}
                >
                  <Box
                    sx={{
                      width: { xs: 50, sm: 70 },
                      height: { xs: 38, sm: 52 },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {formik.values.projectIcon && (
                      <img
                        src={
                          iconList.find((icon) => icon.name === formik.values.projectIcon)?.src
                        }
                        alt="icon"
                        width="69"
                        height="52"
                      />
                    )}
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    width: "100%",
                    p: { xs: "0px", md: "16px 16px 16px 16px" },
                    boxSizing: "border-box",
                  }}
                >
                  <Box
                    sx={{
                      width: "74px",
                      height: "19px",
                      borderRadius: "5px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "#F3F1FF",
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: 400,
                        fontSize: "12px",
                        fontFamily: "Outfit, sans-serif",
                        color: "#7768CC",
                      }}
                    >
                      AVAILABLE
                    </Typography>
                  </Box>

                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        xs: "repeat(4, 1fr)",
                        sm: "repeat(6, 1fr)",
                        md: "repeat(9, 1fr)",
                      },
                      gap: { xs: "10px", sm: "15px" },
                      mt: "13px",
                      width: "100%",
                      backgroundColor: "#FFFFFF",
                      border: "none",
                    }}
                  >
                    {iconList.map(({ name, src }, index) => (
                      <IconButton
                        key={index}
                        onClick={() => formik.setFieldValue("projectIcon", name)}
                        sx={{
                          width: 30,
                          height: 30,
                          backgroundColor:
                            formik.values.projectIcon === name ? "#E3F2FD" : "#F5F5F5",
                          borderRadius: "4px",
                          "&:hover": {
                            backgroundColor:
                              formik.values.projectIcon === name ? "#E3F2FD" : "#E0E0E0",
                          },
                        }}
                      >
                        <img src={src} alt={name} width="30" height="30" />
                      </IconButton>
                    ))}

                  </Box>

                  {formik.touched.projectIcon && formik.errors.projectIcon && (
                    <Typography color="error" fontSize={12} mt={1}>
                      {formik.errors.projectIcon}
                    </Typography>
                  )}
                </Box>

              </Box>
              <Box sx={{
                mt: "20px",
                width: { xs: "auto", md: "302px", },
                height: "48px",
                borderRadius: "3px",
                backgroundColor: "#00344C",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}>
                <Button
                  onClick={handleClick}
                  sx={{
                    fontWeight: 500,
                    fontSize: "16px",
                    lineHeight: "16px",
                    letterSpacing: 1,
                    color: "#FFFFFF",
                    width: "100%",
                    height: "100%",
                    textTransform: "none",
                    fontFamily: "Outfit, sans-serif"
                  }}>
                  Continue
                </Button>
              </Box>
            </Box>
          </Box>

          {/* Right Section (Image) */}
          <Box
            sx={{
              flexShrink: 0,
              width: { xs: "90%", md: "240px", lg: "327px" },
              height: { xs: "250px", md: "270px", lg: "350px" },
              border: "1px solid #ECECEC",
              borderRadius: "3px",
              bgcolor: "#FFFFFF",
              display: "flex",
              flexDirection: "column",
              mt: { xs: 4, md: 0 },
              p: "30px",
              alignSelf: { xs: "center", md: "center" },
            }}
          >
            <Box sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-start",

            }}>
              <Box
                component="img"
                src={ProjectImage}
                alt="Project preview"
                sx={{
                  width: { sm: "200px", md: "238px" },
                  height: "200",
                  objectFit: "contain",
                }}
              />
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column", mt: "18px", gap: "16px" }}>
              <Typography sx={{ fontSize: "16px", fontWeight: "600", lineHeight: "100%", color: "#3F3F3F", fontFamily: "Outfit, sans-serif" }}>
                Manage EPC Project
              </Typography>
              <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "100%", color: "#3F3F3F", fontFamily: "Outfit, sans-serif" }}>
                Manage design projects effectively, visualize tasks, and see team workload
              </Typography>
            </Box>

          </Box>
        </Box>
      </Box>
    </>
  );
};

export default FirstStep;
